import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { currentUser, User } from '../../../../../core/auth';
import { PlantService } from '../../../../../core/plant-configuration/_services/plant.service';
import { AppState } from '../../../../../core/reducers';
import { LayoutUtilsService, QueryParamsModel, QueryResultsModel } from '../../../../../core/_base/crud';
import { SubheaderService } from '../../../../../core/_base/layout';

@Component({
	selector: 'kt-plant-list',
	templateUrl: './plant-list.component.html',
	styleUrls: []
})
export class PlantListComponent implements OnInit, OnDestroy, AfterViewInit {


	// displayedColumns = ['select', 'active', 'login', 'group_name','login_date', 'actions'];
	filterList = [
	];
	columnList = [
		// {name: 'id', displayName: 'ID', def: 'id' },
		{ name: 'name', displayName: 'Nombre', def: 'name' },
		{ name: 'description', displayName: 'Descripción', def: 'description'},
		{ name: 'mqtt_topic', displayName: 'Tópico MQTT', def: 'mqtt_topic' },
		{ name: 'company_name', displayName: 'Empresa', def: 'company_name' },		
		{ name: 'partner_email', displayName: 'Email', def: 'partner_email'},
		{ name: 'partner_mobile', displayName: 'Contacto', def: 'partner_mobile'},
		{ name: 'partner_street', displayName: 'Dirección', def: 'partner_street'},
		{ name: 'partner_rut', displayName: 'Rut', def: 'partner_rut'},
		{ name: 'partner_website', displayName: 'Web', def: 'partner_website'}
	];
	actionBtns = [];
	inited = false;
	dataObs: Subject<QueryResultsModel> = new Subject<QueryResultsModel>();
	deleteObs: Subject<string> = new Subject<string>();
	subscriptions: Subscription[] = [];
	lastQuery: QueryParamsModel;
	
	constructor(
		private plantService: PlantService,
		private activatedRoute: ActivatedRoute,
		private router: Router,
		private layoutUtilsService: LayoutUtilsService,
		private subheaderService: SubheaderService,
		private cdr: ChangeDetectorRef,
		private store: Store<AppState>,
	) { }

	ngOnInit() {
		this.inited = true;
	}

	deleteOne(userId: number) {
		this.subscriptions.push(
			of(null).pipe(
				switchMap(() => this.plantService.delete({ id: userId }))
			).subscribe(status => {
				this.deleteObs.next(status);
			})
		);
	}

	getPage(query: QueryParamsModel) {
		// this.lastQuery = Object.assign(query, {filter: Object.assign(query.filter, {is_installation_contact: 'true'})});
		console.log(`query get page: ${JSON.stringify(query)}`);
		if(query.sortField == null) query.sortField = "plant.id";
		console.log(`query get page after: ${JSON.stringify(query)}`);

		this.subscriptions.push(
			of(null).pipe(
				switchMap(() => this.plantService.getPage(query))
			).subscribe(res => {
				console.log(`query result: ${JSON.stringify(res)}`);
				this.dataObs.next(res);
			})
		);
	}

	refresh() {
		this.getPage(this.lastQuery);
	}

	/**
	 * On Destroy
	 */
	ngOnDestroy() {
		this.subscriptions.forEach(sub => sub.unsubscribe());
	}

	ngAfterViewInit() {
	}
}